<template>
  <div class="content">
    <div class="discount-box-item" v-for="(item,index) in discountList" :key="index">
      <div class="discount-box-default" v-if="item.is_used==0">
        <img class="discount-item-bg" :src="require('../assets/'+appTheme+'/discount_bg.png')" alt="" />
        <div class="discount-box-content justify-align">
          <div class="discount-item">
            <div class="discount-num">
              {{item.discount | filterDiscount}} <span>折</span>
            </div>
            <div class="discount-code">券码：{{item.code}}</div>
          </div>
          <div class="discount-item discount-item-center" @click="clickBtn(item,index)">
            <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div><img :src="require('../assets/'+appTheme+'/q_xiala.png')" class="q_xiala" /> </div>
            <div class="goods-txt uni-ellipsis" v-if="item.shop">店铺：{{item.shop.name}}</div>
            <div class="des-goods uni-ellipsis">{{item.desc}}</div>
            <div class="hint">最终解释权归该商家</div>
          </div>
          <div class="discount-item discount-item-three" @click="clickIsuseBtn(item)">
            <div class="is_use_box left-justifying">
              <div class="">
                <p>立即</p>
                <p>使用</p>
              </div>
              <img :src="require('../assets/'+appTheme+'/discount_arrow_w.png')" class="use-img" />
            </div>
            <div class="date">
              有效期至
            </div>
            <span style="font-size: 2.4vw;">{{item.use_endtime}}</span>
          </div>
        </div>
      </div>
      <!--        已使用-->
      <div class="discount-is-used-box discount-box-default" v-else>
        <img class="discount-item-bg" src="../assets/discount_bg2.png" alt="" />
        <div class="discount-box-content justify-align">
          <div class="discount-item">
            <div class="discount-num">
              {{item.discount | filterDiscount}}<span>折</span>
            </div>
            <div class="discount-code">券码：{{item.code}}</div>
          </div>
          <div class="discount-item discount-item-center">
            <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div><img :src="require('../assets/'+appTheme+'/discount_arrow2.png')" class="q_xiala" /> </div>
            <div class="goods-txt uni-ellipsis" v-if="item.shop">店铺：{{item.shop.name}}</div>
            <div class="des-goods uni-ellipsis">{{item.desc}}</div>
            <div class="hint">最终解释权归该商家</div>
          </div>
          <div class="discount-item discount-item-three">
            <img class="is_use_txt" :src="require('../assets/'+appTheme+'/is_use_txt.png')" alt="" />
            <div class="date">
              有效期至
            </div>
            <span style="font-size: 2.4vw;">{{item.use_endtime}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "discount",
  props: ['discountList','txtType'],
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  computed: {
  },
  data(){
    return {
      appTheme:this.$store.state.appTheme,
    }
  },
  methods: {
    clickBtn(item,index){
      // console.log(item)
      // this.$emit('sendValueToParent',this.value1,this.value2,this.value3,true);传多个值
      this.$emit('sendCoupon',item,index)
    },
    clickIsuseBtn(item){
      this.$router.push({path:'/shopDes',query: {id:item.shop.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-hairline--bottom::after{
  border-bottom-width:0;
}
.discount-box{
  .discount-box-item{
    width: 722px;margin: 25px auto 0;
    .discount-box-default{
      position: relative;

    }
    .discount-item-bg{
      width: 722px;height: auto;display: block;
    }
    .discount-box-content{
      position: absolute;z-index: 2;
      left: 30px;
      top: 30px;
      .discount-num{
        font-weight: bold;font-size: 65px;
        color: #FF953A;
        span{

          font-size: 30px;
        }
      }
      .discount-code{
        font-size: 18px;
        font-weight: 400;
        color: #FF953A;
      }
      .title{
        .title-txt{
          font-size: 28px;
          font-weight: bold;
          color: #E9400B;width: 75%;
          overflow: hidden;
        }
        img{
          width: 12px;display: inline-block;height: auto;margin-left: 20px;
        }
      }
      .discount-item-center{
        padding: 0 10px;font-size: 22px;width: 300px;margin-left: 40px;text-align: left;color: #9E9E9E;
        .goods-txt{
          display: inline-block;
          background: #FFF0E5;
          border-radius: 19px;font-weight: 400;
          color: #FB6666;font-size: 22px;padding: 5px 10px;margin: 10px auto;width:80%;
          overflow: hidden;
        }
        .des-goods{
          width: 90%;margin-bottom: 5px;
          overflow: hidden;
        }
      }
      .discount-item-three{
        padding: 0 20px;font-size: 22px;font-weight: 400;text-align: left;
        color: #FFFFFF;
        .date{
          margin-top: 15px;margin-bottom: 5px;
        }
      }
      .is_use_box{
        font-size: 36px;color: #FFFFFF;

      }
      .use-img{
        width: 48px;display: block;height: auto;margin-left: 15px;
      }
    }
    .discount-is-used-box{
      .discount-box-content{
        .discount-item{
          .discount-num{

            color: #8C8787;
          }
          .discount-code{
            color: #8C8787;
          }
          .title-txt{
            color: #8C8787;
          }
          .goods-txt{
            background: #E6E6E6;color: #8C8787;width: 80%;
          }
          .date{
            margin-top: 10px;
          }
          .is_use_txt{
            width: 122px;display: block;height: auto;margin-top: -5px;
          }
        }
        .discount-item-three{
          span{
            display: block;
          }
        }
      }
    }
  }
}
</style>
